import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private busyRequestCount = 0;
  public isLoading = new BehaviorSubject<boolean>(false);

  show() {
    this.busyRequestCount++;
    this.isLoading.next(true);
  }

  hide() {
    this.busyRequestCount--;

    if (this.busyRequestCount <= 0) {
      this.busyRequestCount = 0;
      this.isLoading.next(false);
    }
  }

  constructor() { }
}
